import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { editField } from "../../../store/fileReducer";

const useTransferTree = (featureNumber = 0) => {
  const {list: zipList, loading: zipListIsLoading }  = useSelector(({ zip }) => zip);
  const dispatch = useDispatch();
  const [searchValRight, setSearchValRight] = useState("");
  const [searchValLeft, setSearchValLeft] = useState("");
  const [selected, setSelected] = useState([]);
  const [left, setLeft] = useState(zipList);
  const [right, setRight] = useState([]);

  useEffect(() => {
    setLeft(zipList)
  }, [zipListIsLoading])
  
  const intersection = (list) =>
    list.filter((item) => selected.includes(`${item.zip}`));

  const not = (a = [], b = []) => a.filter((value) => b.indexOf(value) === -1);

  const leftChecked = intersection(left);
  const rightChecked = intersection(right);

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setSelected([]);
    setSearchValLeft("");
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setSelected([]);
    setSearchValRight("");
  };

  const handleApply = () => {
    const appliedItem = right.map((item) => +item.zip);
    return dispatch(
      editField(
        `root[${featureNumber}].targeting.zip`,
        Array.from(
          new Set([...appliedItem].filter((item) => item !== undefined))
        )
      )
    );
  };

  const handleClearAll = () => {
    setLeft(zipList);
    setRight([]);
    return dispatch(editField(`root[${featureNumber}].targeting.zip`, []));
  };

  return {
    right,
    left,
    leftChecked,
    rightChecked,
    searchValRight,
    setSearchValRight,
    searchValLeft,
    setSearchValLeft,
    selected,
    setSelected,
    handleCheckedRight,
    handleCheckedLeft,
    handleApply,
    handleClearAll,
  };
};

export default useTransferTree;
